var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "go-detail-content", attrs: { id: "contentToPrint" } },
    [
      _c("div", { staticClass: "go-detail go-detail-summary" }, [
        _c("div", { staticClass: "go-detail-header" }, [
          _c("div", { staticClass: "go-block-top" }, [
            _c(
              "span",
              { staticClass: "go-detail-label go-detail-label-summary" },
              [_vm._v(_vm._s(_vm.$t("topic.topic-summary")))]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "go-detail-title" }, [
            _vm._v(_vm._s(_vm.topicDetail.topicTitle)),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "go-block-bottom" }, [
            _c("ul", { staticClass: "go-info-inline" }, [
              _c("li", { staticClass: "go-info-item go-channel" }, [
                _vm._m(0),
                _vm._v(" "),
                _c("span", { staticClass: "go-channel-name" }, [
                  _vm._v(_vm._s(_vm.$t("topic.automatic-summary"))),
                ]),
              ]),
              _vm._v(" "),
              _c("li", { staticClass: "go-info-item go-datetime" }, [
                _c("em", { staticClass: "go-text" }, [
                  _vm._v(
                    _vm._s(
                      _vm.formatDateAgo(
                        _vm.moment.utc(_vm.topicDetail.publishedDate).local(),
                        "YYYYMMDDHHmmss"
                      )
                    )
                  ),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _vm.viewCount > 0
              ? _c("ul", { staticClass: "go-info-inline" }, [
                  _c("li", { staticClass: "go-info-item go-count-view" }, [
                    _c(
                      "svg",
                      {
                        staticClass: "go-icon-18 go-icon-view",
                        attrs: {
                          xmlns: "http://www.w3.org/2000/svg",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          stroke: "#222",
                          "stroke-width": "1",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          width: "18",
                          height: "18",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            stroke: "none",
                            d: "M0 0h24v24H0z",
                            fill: "none",
                          },
                        }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: { d: "M10 12a2 2 0 1 0 4 0a2 2 0 0 0 -4 0" },
                        }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            d: "M21 12c-2.4 4 -5.4 6 -9 6c-3.6 0 -6.6 -2 -9 -6c2.4 -4 5.4 -6 9 -6c3.6 0 6.6 2 9 6",
                          },
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c("em", { staticClass: "go-text" }, [
                      _vm._v(_vm._s(_vm.viewCount)),
                    ]),
                  ]),
                ])
              : _vm._e(),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "go-detail-body" }, [
          _c(
            "div",
            { staticClass: "go-section-main" },
            [
              _c("div", { staticClass: "go-img-area" }, [
                _c("img", {
                  attrs: {
                    id: "topicImage",
                    src: _vm.topicDetail.coverImageUrl,
                  },
                }),
              ]),
              _vm._v(" "),
              _vm._l(_vm.topicDetail.topicContent, function (item, index1) {
                return _c("p", { key: index1 }, [_vm._v(_vm._s(item))])
              }),
            ],
            2
          ),
          _vm._v(" "),
          _c("div", { staticClass: "go-section-sub" }, [
            _c("div", { staticClass: "go-scetion-header" }, [
              _c("div", { staticClass: "go-scetion-title" }, [
                _vm._v(_vm._s(_vm.$t("topic.subtopic"))),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "go-scetion-body" }, [
              _c(
                "div",
                { staticClass: "go-summary-sub" },
                _vm._l(_vm.topicDetail.subTopics, function (subTopics, index2) {
                  return _c(
                    "div",
                    { key: index2, staticClass: "go-summary-item" },
                    [
                      _c("div", { staticClass: "go-summary-title" }, [
                        _vm._v(_vm._s(subTopics.subTopicTitle)),
                      ]),
                      _vm._v(" "),
                      _vm._l(
                        subTopics.subTopicContent,
                        function (subTopicContent, index3) {
                          return _c(
                            "p",
                            {
                              key: index3 + index2,
                              staticClass: "go-summary-desc",
                            },
                            [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(subTopicContent) +
                                  "\n                "
                              ),
                            ]
                          )
                        }
                      ),
                      _vm._v(" "),
                      _c(
                        "ul",
                        { staticClass: "go-card-reference-inline" },
                        _vm._l(
                          subTopics.subTopicDocList,
                          function (subTopicDocList, index4) {
                            return _c(
                              "li",
                              {
                                key: index2 + index4,
                                staticClass: "go-list-item",
                              },
                              [
                                _c("div", { staticClass: "go-card" }, [
                                  _c("div", { staticClass: "go-card-title" }, [
                                    _vm._v(_vm._s(subTopicDocList.docTitle)),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "a",
                                    {
                                      staticClass: "go-list-link",
                                      attrs: {
                                        href: subTopicDocList.docUrl,
                                        target: "_blank",
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "go-icon-20 go-icon-newwindow",
                                      }),
                                    ]
                                  ),
                                ]),
                              ]
                            )
                          }
                        ),
                        0
                      ),
                    ],
                    2
                  )
                }),
                0
              ),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _vm.briefingPageId
          ? _c("div", { staticClass: "go-detail-footer" }, [
              _c("div", { staticClass: "go-content-owner" }, [
                _c("a", { staticClass: "go-title" }, [
                  _vm._v(_vm._s(_vm.detailSocialBP.briefingPageName)),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "go-info-inline" }, [
                  _c("span", { staticClass: "go-info-item go-user-info" }, [
                    _c("div", { staticClass: "go-user-thumb" }, [
                      _c("img", {
                        attrs: {
                          src: _vm.detailSocialBP.userProfile.imageUrl
                            ? _vm.detailSocialBP.userProfile.imageUrl
                            : _vm.onErrorImageAvatar,
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("a", { staticClass: "go-user-name" }, [
                      _vm._v(_vm._s(_vm.detailSocialBP.userProfile.lastName)),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "go-info-item go-count" }, [
                    _c("strong", [
                      _vm._v(_vm._s(_vm.detailSocialBP.subscribeCount)),
                    ]),
                    _vm._v("Subscribers\n            "),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "go-elements" }, [
                _c(
                  "button",
                  {
                    class: [
                      "btn go-btn-subscribe",
                      { active: _vm.subscribeStatus === "SUBSCRIBE" },
                    ],
                    attrs: {
                      type: "button",
                      "data-toggle": "button",
                      "aria-pressed": "true",
                      disabled: _vm.isLoadingSubcribe,
                    },
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.toggleSubscribed()
                      },
                    },
                  },
                  [
                    _vm.subscribeStatus === "SUBSCRIBE"
                      ? [
                          _c("span", { staticClass: "go-toggle-on" }, [
                            _c("i", {
                              staticClass: "go-icon-18 go-icon-subscribe-on",
                            }),
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "publicNotificationSummaryDetail.subscribing"
                                )
                              ) + "\n              "
                            ),
                          ]),
                        ]
                      : [
                          _c("span", { staticClass: "go-toggle-off" }, [
                            _c("i", {
                              staticClass: "go-icon-18 go-icon-subscribe",
                            }),
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "publicNotificationSummaryDetail.subscribe"
                                )
                              ) + "\n              "
                            ),
                          ]),
                        ],
                  ],
                  2
                ),
              ]),
            ])
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "go-channel-thumb" }, [
      _c("img", {
        attrs: {
          src: "content/images/common/goover_favicon.ico",
          alt: "goover",
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }